import { createContext } from 'react';
import type { Me } from '@medicail/shared';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthContextValue {
  me: Me | null;
  status: AuthStatus;
  signOut(): Promise<void>;
  /** Re-read the session and /api/me (call after a successful sign in). */
  refresh(): Promise<void>;
  /** One shot message to show on the sign in page (e.g. account disabled). */
  notice: string | null;
  clearNotice(): void;
  mode: 'cognito' | 'dev';
}

export const AuthContext = createContext<AuthContextValue | null>(null);
